/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Discord_UserInputs */



/**
* | output |
* | --- |
* | "Failed to get Discord user info." |
*
* @param {Login_Error_Discord_UserInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_error_discord_user = /** @type {((inputs?: Login_Error_Discord_UserInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Discord_UserInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la récupération des informations utilisateur Discord.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al obtener información de usuario de Discord.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao obter informações do usuário Discord.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile ottenere le informazioni utente da Discord.")
	return /** @type {LocalizedString} */ ("Failed to get Discord user info.")
});